export default __webpack_public_path__ + "static/media/Large conference room_V.3.662eecf3.png";